import React, {useState,useEffect, setGlobal, getGlobal} from 'reactn';
import {Button, Modal, Skeleton, Input, message } from 'antd';
import { useFirestore, useStorage } from 'reactfire';
import SingleTest from './components/singleTest';
import SingleShowTest from './components/singleShowTest';
import ManageFavourites from './components/manageFav';
import SearchTests from './components/searchTests';
import firebase from '../../firebase';
import { PrinterOutlined } from '@ant-design/icons';

const Investigation = () => {
const [tests, setTests] = useState([]);
const firestore = useFirestore();
const [loading, setLoading] = useState(false);

const { Search } = Input;

const storage = useStorage();

const [testName, setTestNames] = useState([]);
const [favLIst , setFavList] = useState([]);

const query_tests = firestore.collection("Investigation_records");
const query_fav = firestore.collection('Favourite_Investigation');

const [isModalVisible, setIsModalVisible] = useState(false);
const [favLoading, setFavLoading] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    getAllTestsTaken();
    getAllRecords();
  }, []);


  const getAllRecords = () => {
    let records = [];
    setLoading(true);
    query_fav.orderBy('timestamp').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            records.push({value  : doc.data(), id: doc.id});
        });
        setFavList(records);
        setLoading(false);
        setFavLoading(false);
    });
}

  const getAllTestsTaken = () => {
    let records = [];
    query_tests.orderBy('timestamp').where("appointment_id", "==", getGlobal().appointmentId).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
          records.push({value: doc.data().test_info, id: doc.id, image: doc.data().test_image_url});
      });
      setTests(records);
    });
  }

  const recordUpdate = (index) => {
    console.log(index);
    var dummarr = [...testName];
    if (index !== -1) {
      dummarr.splice(index, 1);
      setTestNames(dummarr);
    }
    getAllTestsTaken();
  }

  const onSelect = (data) => {
    setTestNames([data, ...testName]);
  };

  const manageFavoriteModal = () => {
    setIsModalVisible(true);
  }

  const submitFav = (favListName) => {
    setFavLoading(true);
    query_fav.add({
      favourite_list_name: favListName,
      timestamp: new Date(),
      }).then(() => {
        message.success('Favorite list added successfully');
        getAllRecords();
    });
  }

  const onDeleteFavList = () => {
    getAllRecords();
  }

  const favLIstSelected = (favListarg) => {
    console.log(favListarg.value.Investigation_list);
    if (favListarg.value.Investigation_list) {
      setTestNames(favListarg.value.Investigation_list);
    }
  }

  const printthis = () => {
    window.focus();
    window.print();
    return true;
  }

  return (
    <div style={{position: 'relative'}}>
      <Button style={{position : 'absolute', top: '-30px', right: '0px'}} className="SaveFormButton" onClick={manageFavoriteModal} type="primary">Manage Favorites</Button>
      <div style={{display: 'flex'}}>
        <SearchTests onSelectProp = {onSelect} />
      </div>
      {loading ? <Skeleton active /> : <>
      <div className='showFavListing'>
          <h3>Favorite Lists :</h3>
          <ul>
            {favLIst.map((singleFav) => {
              return <li key={singleFav.id} onClick={() => favLIstSelected(singleFav)}>{singleFav.value.favourite_list_name}</li>
            })}
          </ul>
      </div>
      <div className="tests_container">
        {testName && (
          <div className="tests_wrapper">
            {testName && testName.length > 0 && <h3>Taken Tests</h3>}
            <ul className='taken_tests'>
              {testName && testName.map((test, index) => {
                return <SingleTest key={Math.random()} testname={test} recAdded={() => recordUpdate(index)} />
              })}
              {/* {testName && testName.length > 0 && <Button>Submit All</Button>} */}
            </ul>
          </div>
        )}
        <div className='showTestsTaken'>
          
          {tests && tests.length > 0 && <div className="showViewHeading"><h3>View current Tests</h3> <span onClick={printthis}><PrinterOutlined /></span></div>}
            {tests && tests.length > 0 && <ul>
              {tests && tests.map((te) => {
                return <SingleShowTest key={Math.random()} test_name={te.value.testname} test_desc={te.value.note} image={te.image} id={te.id} deletedRecord={recordUpdate} />
              })}
            </ul>}
        </div>

      </div>
      </>}
    <Modal title="Manage and add favourites investigation" width='60%' footer={null} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>



    <Search
      placeholder="Add Favourites list"
      allowClear
      enterButton="Submit"
      style={{width: '50%', margin: '0 auto', display: 'block'}}
      size="large"
      loading={favLoading}
      onSearch={(value) => submitFav(value)}
    />
    <ManageFavourites favRecords={favLIst} refreshFavList={onDeleteFavList} />

    </Modal>

    </div>
  );
}

export default Investigation;
